import type { AxiosResponse } from 'axios';
import type { AreaLocation } from '@app-types/models/area';
import api from './api';

interface AreaLocationsResponse {
  locations: AreaLocation[];
  [key: string]: unknown;
}

export const getAreaLocations = async (): Promise<AreaLocationsResponse> => {
  try {
    const response: AxiosResponse<AreaLocationsResponse> = await api.get('/areas/locations');
    return response.data;
  } catch (error: unknown) {
    console.error('Error fetching area locations:', error);
    throw error;
  }
};
